import {
  getFromLocalStorage,
  saveToLocalStorage,
  removeFromLocalStorage,
} from "@utils/localStorage";
import { DEMO_GUEST_TOKEN_KEY } from "@constants/guestAgenda";

// Phase 2 (guest demo): helpers for the anonymous-visitor demo token. The token
// is attached to demo-runtime requests (see rtkApiHelpers) and identifies the
// demo agenda the guest is allowed to drive.

export const getDemoGuestToken = () =>
  getFromLocalStorage(DEMO_GUEST_TOKEN_KEY);

export const setDemoGuestToken = (token) =>
  saveToLocalStorage(DEMO_GUEST_TOKEN_KEY, token);

export const clearDemoGuestToken = () =>
  removeFromLocalStorage(DEMO_GUEST_TOKEN_KEY);

export const hasDemoGuestToken = () => !!getDemoGuestToken();
